export function isForbiddenError(error) {
  return error?.response?.status === 403 || error?.response?.data?.error === 'forbidden';
}

export function workspaceAccessMessage(error, fallbackMessage) {
  if (isForbiddenError(error)) {
    return fallbackMessage || 'You do not have access to this workspace page.';
  }

  return (
    error?.response?.data?.error ||
    error?.message ||
    fallbackMessage ||
    'Something went wrong while loading this page.'
  );
}
